import { Page } from '@dixa/lib-shared-habla';

import { ExportConversationsBanner } from './components/banner/exportConversationsBanner';
import { ExportConversationsForm } from './components/form/exportConversationsForm';

export const SettingsExportConversationsView = (): JSX.Element => {
  return (
    <Page>
      <Page.Head title="Export conversations" />

      <Page.Body>
        <Page.Section callout={<ExportConversationsBanner />}>
          <ExportConversationsForm />
        </Page.Section>
      </Page.Body>
    </Page>
  );
};
